var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"flex-1 w-full bg-gray-100"},[_c('PageHeading',[_vm._v(" Advocates ")]),_c('section',{staticStyle:{"height":"380px"}},[_c('BaseDirectory')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }